import React, { useState } from "react";
import DataTable from "../../components/DataTable";
import PageWrapperForm from "../../components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { ExtraServiceManagementConfig } from "../../config/tableConfigs";
import ExtraServiceFormModal from "./components/ExtraServiceFormModal";
import DeleteModal from "../../components/DeleteModal";
import { useSession } from "hooks/useSession";

const ExtraServiceManagementPage = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedService, setSelectedService] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const { userid } = useSession();

  const handleAddService = () => {
    setModalMode("add");
    setSelectedService(null);
    setModalShow(true);
  };

  const formdata = new FormData();
  formdata.append("action", "GET");        // ✅ action field, matches request.POST.get("action")

  const tableData = useTableDataWithPost(
    `https://pro.mokshiq.in/extra_service_action`,
    ExtraServiceManagementConfig,
    formdata,
    refresh
  );

  const handleView = (service) => {
    console.log("Viewing extra service:", service);
  };

  const handleEditService = (service) => {
    setModalMode("edit");
    setSelectedService(service);
    setModalShow(true);
  };

  const handleDelete = (service) => {
    setSelectedService(service);
    setTimeout(() => {
      const modalEl = document.getElementById("deleteextraservice1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      setRefresh((prev) => prev + 1);
    }
  };

  const handleFormSuccess = () => {
    setRefresh((prev) => prev + 1);
    setModalShow(false);
  };

  const handleDeleteSuccess = () => {
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <PageWrapperForm
        config={ExtraServiceManagementConfig}
        handleOnclick={handleAddService}
        buttonTitle="Add Extra Service"
      >
        <DataTable
          config={ExtraServiceManagementConfig}
          tableData={tableData}
          onView={handleView}
          onEdit={handleEditService}
          onDelete={handleDelete}
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>

      <ExtraServiceFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedService}   // has: { name, category, description, image, material_click, web_url, status } from GET
        onSuccess={handleFormSuccess}
      />

      <DeleteModal
        deleteid={selectedService?.id}
        id="deleteextraservice1"
        title="Delete Extra Service"
        message="Are you sure you want to delete this extra service?"
        apiUrl="https://pro.mokshiq.in/extra_service_action"
        deleteKey="id"                  // ✅ matches request.POST.get("id") in the DELETE branch
        action="DELETE"
        onSuccess={handleDeleteSuccess}
      />
    </div>
  );
};

export default ExtraServiceManagementPage;